import React from "react";
import "./_homeItemGalleryCard.scss";
import { Link, useNavigate } from "react-router-dom";

const HomeItemGalleryCard = ({ product }) => {
  const navigate = useNavigate();
  // Get the primary image URL (or fall back to the first image)
  let imageUrl = "";
  if (product.images && product.images.length > 0) {
    const primary = product.images.find((img) => img.id === product.primaryImageId);
    imageUrl = primary ? primary.url : product.images[0].url;
  }

  const navigateToProduct = (event) => {
    event.preventDefault();
    navigate(`/product/${product.id}`);
  };
  return (
    <div className="productCard">
      <div className="productCardImage">
        <img src={imageUrl} alt={product.productName} />
      </div>
      <div className="productCardOverlay">
        <h3 className="productCardTitle">{product.productName}</h3>
        <div className="productCardPrice">
          <span className="price">₪{product.price}</span>
        </div>
        <p className="productCardDescription">{product.description && product.description.length > 100 ? product.description.substring(0, 100) + "..." : product.description}</p>
        <button className="primaryButton" onClick={navigateToProduct}>
          פרטים נוספים
        </button>
      </div>
    </div>
  );
};

export default HomeItemGalleryCard;
